<template>
<div class="">
    <p><span @click="$store.commit('search/SET_BACKBTN_RESULTS', true),$router.back()" class="btn btn-clear">Back</span></p>
</div>
</template>

<script>
export default {
    name: 'BackButton',
}
</script>
